export default [
    {
		path: "/setpassword/:token?",
		component: () => import("../views/Password/Reset.vue"),
		meta: {
			hasmainmenu: false,
		}
	}
]